var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"button_animation",staticClass:"button button--progress",class:_vm.extraClass,on:{"mousedown":_vm.mouseDown,"mouseup":_vm.mouseUp,"touchstart":_vm.mouseDown,"touchend":_vm.mouseUp}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }